import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    // 文案
    '--word-color01': '#333333',
    '--word-color02': '#000000',
    '--word-color03': '#F8A92D',
    '--word-color04': '#666666',
    '--word-color05': '#333333',
    '--word-color06': '#333333',
    '--word-color07': '#333333',
    '--word-color08': '#6849A6',
    '--word-color09': '#6849A6',
    '--word-color10': '#b2b2b2',
    '--word-color11': '#333333',
    '--word-color12': '#ffffff',
    '--word-color13': '#ffffff',
    '--word-color14': '#333333',
    '--word-color15': '#666666',
    '--word-color16': '#a338fc',
    '--word-color17': '#c0a2c2',
    '--word-color18': '#b2b2b2',
    '--word-color19': '#b2b2b2',
    '--word-color20': '#b2b2b2',
    '--word-color21': '#b2b2b2',
    '--word-color22': '#b2b2b2',
    '--word-color23': '#b2b2b2',
    '--word-color24': '#000000',
    '--word-color25': '#ff4265',
    '--word-color26': '#000000',
    '--word-color27': '#000000',
    // 背景
    '--bg-color01': '#f9f9fb',
    '--bg-color02': '#fefefe',
    '--bg-color03': '#fefefe',
    '--bg-color04': '#AB55FE',
    '--bg-color05': '#f4f5f7',
    '--bg-color06': '#faedff',
    '--bg-color07': 'linear-gradient(90deg, #8654F1 0%, #652BBE 100%)',
    // 图片资源
    '--icon-img01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon.webp')})`,
    '--icon-img02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon-ar.webp')})`,
    '--icon-img03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-on.webp')})`,
    '--icon-img04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-off.webp')})`,
    '--coupon-on-img': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/coupon-on.webp')})`,
    // 优惠券
    '--coupon-drawer-bg': '#eeeef1',
    '--coupon-card-bg': 'linear-gradient(95deg, #FBF7FA 0%, #FAF6FC 98.4%)',
    '--coupon-color-name': '#333333',
    '--coupon-color-desc': '#666666',
    '--coupon-color-date': '#B2B2B2',
    '--coupon-color-amount': '#A338FC',
    '--coupon-color-unit': '#C0A2C2',
    '--most-favorable-color': '#A338FC',
    '--most-favorable-bg': 'rgba(171, 85, 254, 0.10)',
    // 圆角
    '--page-radius01': '100px',
  },
  echo: {
    // 文案
    '--word-color01': '#222222',
    '--word-color02': '#222222',
    '--word-color03': '#F8A92D',
    '--word-color04': '#222222',
    '--word-color05': '#222222',
    '--word-color06': '#222222',
    '--word-color07': '#222222',
    '--word-color08': '#FF7F2D',
    '--word-color09': '#FF7F2D',
    '--word-color10': '#999999',
    '--word-color11': '#222222',
    '--word-color12': '#ffffff',
    '--word-color13': '#ffffff',
    '--word-color14': '#222222',
    '--word-color15': '#222222',
    '--word-color16': '#ff7f2d',
    '--word-color17': '#ffc9a8',
    '--word-color18': '#999999',
    '--word-color19': '#999999',
    '--word-color20': '#999999',
    '--word-color21': '#999999',
    '--word-color22': '#999999',
    '--word-color23': '#999999',
    '--word-color24': '#222222',
    '--word-color25': '#f95151',
    '--word-color26': '#222222',
    '--word-color27': '#222222',
    // 背景
    '--bg-color01': '#f4f5f7',
    '--bg-color02': '#fefefe',
    '--bg-color03': '#fefefe',
    '--bg-color04': '#ff7f2d',
    '--bg-color05': '#f4f5f7',
    '--bg-color06': '#FFF7EA',
    '--bg-color07': '#ff7f2d',
    // 图片资源
    '--icon-img01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-icon.webp')})`,
    '--icon-img02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-icon-ar.webp')})`,
    '--icon-img03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-on.webp')})`,
    '--icon-img04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-off.webp')})`,
    '--coupon-on-img': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/coupon-on.webp')})`,
    // 优惠券
    '--coupon-drawer-bg': '#eeeef1',
    '--coupon-card-bg': '#FFFBF2',
    '--coupon-color-name': '#202326',
    '--coupon-color-desc': '#353A3F',
    '--coupon-color-date': '#B2B2B2',
    '--coupon-color-amount': '#FF7F2D',
    '--coupon-color-unit': '#C2916C',
    '--most-favorable-color': '#FF7F2D',
    '--most-favorable-bg': 'rgba(255, 135, 29, 0.10)',
    // 圆角
    '--page-radius01': '100px',
  },
  joychat: {
    // 文案
    '--word-color01': '#222222',
    '--word-color02': '#222222',
    '--word-color03': '#F8A92D',
    '--word-color04': '#222222',
    '--word-color05': '#222222',
    '--word-color06': '#222222',
    '--word-color07': '#222222',
    '--word-color08': '#063D28',
    '--word-color09': '#063D28',
    '--word-color10': '#999999',
    '--word-color11': '#222222',
    '--word-color12': '#ffffff',
    '--word-color13': '#ffffff',
    '--word-color14': '#222222',
    '--word-color15': '#666666',
    '--word-color16': '#22c185',
    '--word-color17': '#9edfc4',
    '--word-color18': '#999999',
    '--word-color19': '#999999',
    '--word-color20': '#999999',
    '--word-color21': '#999999',
    '--word-color22': '#999999',
    '--word-color23': '#999999',
    '--word-color24': '#222222',
    '--word-color25': '#f95151',
    '--word-color26': '#222222',
    '--word-color27': '#222222',
    // 背景
    '--bg-color01': '#f9f9fb',
    '--bg-color02': '#fefefe',
    '--bg-color03': '#fefefe',
    '--bg-color04': '#22c185',
    '--bg-color05': '#f4f5f7',
    '--bg-color06': '#D7FFEE',
    '--bg-color07': '#22c185',
    // 图片资源
    '--icon-img01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-icon.webp')})`,
    '--icon-img02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-icon-ar.webp')})`,
    '--icon-img03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-on.webp')})`,
    '--icon-img04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-off.webp')})`,
    '--coupon-on-img': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/coupon-on.webp')})`,
    // 优惠券
    '--coupon-drawer-bg': '#eeeef1',
    '--coupon-card-bg': '#F5FFFC',
    '--coupon-color-name': '#202326',
    '--coupon-color-desc': '#353A3F',
    '--coupon-color-date': '#B2B2B2',
    '--coupon-color-amount': '#0EAF6D',
    '--coupon-color-unit': '#84C884',
    '--most-favorable-color': '#0EAF6D',
    '--most-favorable-bg': 'rgba(29, 255, 29, 0.10)',
    // 圆角
    '--page-radius01': '100px',
  },
  joyu: {
    // 文案
    '--word-color01': '#0C0E11',
    '--word-color02': '#0C0E11',
    '--word-color03': '#F8A92D',
    '--word-color04': '#353A3F',
    '--word-color05': '#0C0E11',
    '--word-color06': '#0C0E11',
    '--word-color07': '#353A3F',
    '--word-color08': '#5A0B1B',
    '--word-color09': '#5A0B1B',
    '--word-color10': '#8E9092',
    '--word-color11': '#0C0E11',
    '--word-color12': '#5A0B1B',
    '--word-color13': '#5A0B1B',
    '--word-color14': '#0C0E11',
    '--word-color15': '#353A3F',
    '--word-color16': '#FF6A55',
    '--word-color17': '#ffb5a8',
    '--word-color18': '#8E9092',
    '--word-color19': '#8E9092',
    '--word-color20': '#8E9092',
    '--word-color21': '#8E9092',
    '--word-color22': '#8E9092',
    '--word-color23': '#8E9092',
    '--word-color24': '#0C0E11',
    '--word-color25': '#FF5526',
    '--word-color26': '#0C0E11',
    '--word-color27': '#0C0E11',
    // 背景
    '--bg-color01': '#F4F5F7',
    '--bg-color02': '#ffffff',
    '--bg-color03': '#ffffff',
    '--bg-color04': '#FF6A55',
    '--bg-color05': '#F4F5F7',
    '--bg-color06': '#FFECDD',
    '--bg-color07': '#FF6A55',
    // 图片资源
    '--icon-img01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-icon.webp')})`,
    '--icon-img02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-icon-ar.webp')})`,
    '--icon-img03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-on.webp')})`,
    '--icon-img04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-off.webp')})`,
    '--coupon-on-img': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/coupon-on.webp')})`,
    // 优惠券
    '--coupon-drawer-bg': '#eeeef1',
    '--coupon-card-bg': '#FFF5F7',
    '--coupon-color-name': '#202326',
    '--coupon-color-desc': '#353A3F',
    '--coupon-color-date': '#B2B2B2',
    '--coupon-color-amount': '#FF5577',
    '--coupon-color-unit': 'rgba(87, 19, 37, 0.50)',
    '--most-favorable-color': '#7A580D',
    '--most-favorable-bg': '#FFFADA',
    // 圆角
    '--page-radius01': '4px',
  },
  kiko: {
    // 文案
    '--word-color01': '#333333',
    '--word-color02': '#333333',
    '--word-color03': '#F8A92D',
    '--word-color04': '#666666',
    '--word-color05': '#333333',
    '--word-color06': '#333333',
    '--word-color07': '#333333',
    '--word-color08': '#937A15',
    '--word-color09': '#937A15',
    '--word-color10': '#b2b2b2',
    '--word-color11': '#333333',
    '--word-color12': '#000000',
    '--word-color13': '#000000',
    '--word-color14': '#333333',
    '--word-color15': '#666666',
    '--word-color16': '#ffe242',
    '--word-color17': '#fff0a8',
    '--word-color18': '#b2b2b2',
    '--word-color19': '#b2b2b2',
    '--word-color20': '#b2b2b2',
    '--word-color21': '#b2b2b2',
    '--word-color22': '#b2b2b2',
    '--word-color23': '#b2b2b2',
    '--word-color24': '#333333',
    '--word-color25': '#ff4265',
    '--word-color26': '#333333',
    '--word-color27': '#333333',
    // 背景
    '--bg-color01': '#f9f9fb',
    '--bg-color02': '#fefefe',
    '--bg-color03': '#fefefe',
    '--bg-color04': '#ffe242',
    '--bg-color05': '#f4f5f7',
    '--bg-color06': '#FFFCE6',
    '--bg-color07': '#ffe242',
    // 图片资源
    '--icon-img01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-icon.webp')})`,
    '--icon-img02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-icon-ar.webp')})`,
    '--icon-img03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-on.webp')})`,
    '--icon-img04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-off.webp')})`,
    '--coupon-on-img': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/coupon-on.webp')})`,
    // 优惠券
    '--coupon-drawer-bg': '#eeeef1',
    '--coupon-card-bg': '#FFFBF2',
    '--coupon-color-name': '#202326',
    '--coupon-color-desc': '#353A3F',
    '--coupon-color-date': '#B2B2B2',
    '--coupon-color-amount': '#937A15',
    '--coupon-color-unit': '#C2916C',
    '--most-favorable-color': '#937A15',
    '--most-favorable-bg': '#FFF7B3',
    // 圆角
    '--page-radius01': '100px',
  },
  vava: {
    // 文案
    '--word-color01': '#333333',
    '--word-color02': '#000000',
    '--word-color03': '#F8A92D',
    '--word-color04': '#666666',
    '--word-color05': '#333333',
    '--word-color06': '#333333',
    '--word-color07': '#333333',
    '--word-color08': '#6849A6',
    '--word-color09': '#6849A6',
    '--word-color10': '#b2b2b2',
    '--word-color11': '#333333',
    '--word-color12': '#ffffff',
    '--word-color13': '#ffffff',
    '--word-color14': '#333333',
    '--word-color15': '#666666',
    '--word-color16': '#a338fc',
    '--word-color17': '#c0a2c2',
    '--word-color18': '#b2b2b2',
    '--word-color19': '#b2b2b2',
    '--word-color20': '#b2b2b2',
    '--word-color21': '#b2b2b2',
    '--word-color22': '#b2b2b2',
    '--word-color23': '#b2b2b2',
    '--word-color24': '#000000',
    '--word-color25': '#ff4265',
    '--word-color26': '#000000',
    '--word-color27': '#000000',
    // 背景
    '--bg-color01': '#f9f9fb',
    '--bg-color02': '#fefefe',
    '--bg-color03': '#fefefe',
    '--bg-color04': '#AB55FE',
    '--bg-color05': '#f4f5f7',
    '--bg-color06': '#faedff',
    '--bg-color07': 'linear-gradient(90deg, #8654F1 0%, #652BBE 100%)',
    // 图片资源
    '--icon-img01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon.webp')})`,
    '--icon-img02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon-ar.webp')})`,
    '--icon-img03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-on.webp')})`,
    '--icon-img04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-off.webp')})`,
    '--coupon-on-img': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/coupon-on.webp')})`,
    // 优惠券
    '--coupon-drawer-bg': '#eeeef1',
    '--coupon-card-bg': 'linear-gradient(95deg, #FBF7FA 0%, #FAF6FC 98.4%)',
    '--coupon-color-name': '#333333',
    '--coupon-color-desc': '#666666',
    '--coupon-color-date': '#B2B2B2',
    '--coupon-color-amount': '#A338FC',
    '--coupon-color-unit': '#C0A2C2',
    '--most-favorable-color': '#A338FC',
    '--most-favorable-bg': 'rgba(171, 85, 254, 0.10)',
    // 圆角
    '--page-radius01': '100px',
  },
  vibeo: {
    // 文案
    '--word-color01': '#333333',
    '--word-color02': '#333333',
    '--word-color03': '#F8A92D',
    '--word-color04': '#666666',
    '--word-color05': '#333333',
    '--word-color06': '#333333',
    '--word-color07': '#333333',
    '--word-color08': '#733406',
    '--word-color09': '#733406',
    '--word-color10': '#b2b2b2',
    '--word-color11': '#333333',
    '--word-color12': '#733406',
    '--word-color13': '#733406',
    '--word-color14': '#333333',
    '--word-color15': '#666666',
    '--word-color16': '#ffa433',
    '--word-color17': '#ffd9a8',
    '--word-color18': '#b2b2b2',
    '--word-color19': '#b2b2b2',
    '--word-color20': '#b2b2b2',
    '--word-color21': '#b2b2b2',
    '--word-color22': '#b2b2b2',
    '--word-color23': '#b2b2b2',
    '--word-color24': '#333333',
    '--word-color25': '#ff4265',
    '--word-color26': '#333333',
    '--word-color27': '#333333',
    // 背景
    '--bg-color01': '#f9f9fb',
    '--bg-color02': '#fefefe',
    '--bg-color03': '#fefefe',
    '--bg-color04': '#ffa433',
    '--bg-color05': '#f4f5f7',
    '--bg-color06': '#FFF4D6',
    '--bg-color07': '#ffa433',
    // 图片资源
    '--icon-img01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-icon.webp')})`,
    '--icon-img02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-icon-ar.webp')})`,
    '--icon-img03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-on.webp')})`,
    '--icon-img04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-off.webp')})`,
    '--coupon-on-img': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/coupon-on.webp')})`,
    // 优惠券
    '--coupon-drawer-bg': '#eeeef1',
    '--coupon-card-bg': '#FFFBF2',
    '--coupon-color-name': '#202326',
    '--coupon-color-desc': '#353A3F',
    '--coupon-color-date': '#B2B2B2',
    '--coupon-color-amount': '#FF871D',
    '--coupon-color-unit': '#C2916C',
    '--most-favorable-color': '#FF871D',
    '--most-favorable-bg': 'rgba(255, 135, 29, 0.10)',
    // 圆角
    '--page-radius01': '100px',
  },
  whonow: {
    // 文案
    '--word-color01': '#0C0E11',
    '--word-color02': '#222222',
    '--word-color03': '#F8A92D',
    '--word-color04': '#666666',
    '--word-color05': '#222222',
    '--word-color06': '#222222',
    '--word-color07': '#222222',
    '--word-color08': '#102006',
    '--word-color09': '#102006',
    '--word-color10': '#b2b2b2',
    '--word-color11': '#222222',
    '--word-color12': '#102006',
    '--word-color13': '#102006',
    '--word-color14': '#222222',
    '--word-color15': '#222222',
    '--word-color16': '#B9E86F',
    '--word-color17': '#d4e8a8',
    '--word-color18': '#999999',
    '--word-color19': '#999999',
    '--word-color20': '#999999',
    '--word-color21': '#999999',
    '--word-color22': '#999999',
    '--word-color23': '#999999',
    '--word-color24': '#222222',
    '--word-color25': '#F95151',
    '--word-color26': '#222222',
    '--word-color27': '#222222',
    // 背景
    '--bg-color01': '#F4F5F7',
    '--bg-color02': '#ffffff',
    '--bg-color03': '#ffffff',
    '--bg-color04': '#B9E86F',
    '--bg-color05': '#F4F5F7',
    '--bg-color06': '#EAF5C8',
    '--bg-color07': '#B9E86F',
    // 图片资源
    '--icon-img01': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-icon.webp')})`,
    '--icon-img02': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-icon-ar.webp')})`,
    '--icon-img03': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-on.webp')})`,
    '--icon-img04': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-off.webp')})`,
    '--coupon-on-img': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/coupon-on.webp')})`,
    // 优惠券
    '--coupon-drawer-bg': '#eeeef1',
    '--coupon-card-bg': '#F6FDE8',
    '--coupon-color-name': '#202326',
    '--coupon-color-desc': '#353A3F',
    '--coupon-color-date': '#B2B2B2',
    '--coupon-color-amount': '#7CA631',
    '--coupon-color-unit': 'rgba(62, 87, 19, 0.50)',
    '--most-favorable-color': '#7CA631',
    '--most-favorable-bg': '#F6FDE8',
    // 圆角
    '--page-radius01': '100px',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      const base = getBaseFeature()
      const pkg = this.packageName && styObj[this.packageName] ? styObj[this.packageName] : styObj.default
      return { ...base, ...pkg }
    },
  },
}
